export default __webpack_public_path__ + "static/apis-requiem-89368ae6b96619bd8107250e1bb48ce5.png";